import React, { useState } from 'react'
import { Chip, Hidden } from '@mui/material';
import { CLOUD_KITCHEN_SUB_TEXT } from "../../../global/constants";
import {
    CLOUD_TEST_1_JPG,
    CLOUD_TEST_2_JPG,
    CLOUD_TEST_3_JPG,
    CLOUD_TEST_4_JPG,
    CLOUD_TEST_5_JPG,
    CLOUD_TEST_6_JPG,
    CLOUD_TEST_7_JPG,
    CLOUD_TEST_8_JPG,
    CLOUD_TEST_9_JPG,
    CELEBRITY_CHEF_PNG
} from '../../../global/assets/Icons';
import fallBackImage from '../../../global/assets/png/clock-blue.png'
import Loader from '../../../composed/Loader/Loader';
import { MealOfferingCalculation } from './../../../global/calculations';



const CloudKitchen = (props) => {

    const { cloudKitchenList, handleClickRedirect, customerInfoData } = props
    const [imageLoaded, setImageLoaded] = useState([])
    const [imageError, setImageError] = useState([])
    const { loading, data, success, errorMessage } = customerInfoData
    const custInfoData = data?.data || [];
    const custMealPlan = custInfoData?.meal_Package?.meal_plan;
    // console.log('----cloudKitchenList', cloudKitchenList)



    const onImageLoad = (index) => {
        setImageLoaded((prev) => {
            prev[index] = true;
            return [...prev];
        })

    }

    const onImageError = (index) => {
        setImageError((prev) => {
            prev[index] = true;
            return [...prev];
        })

        setImageLoaded((prev) => {
            prev[index] = true;
            return [...prev];
        })
    }
    // console.log('----CloudKitchen', cloudKitchenList)
    return (
        <>
            <div style={{ cursor: 'pointer', width: '700px', height: '450px', marginBottom: '25px', marginTop: '10px', position: 'relative', border: '2px solid #181436', borderRadius: '5px', backgroundColor: '#F8F8F8', overflow: 'hidden' }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    borderBottom: '1px solid #F1F1F1',
                    height: '75px',
                    width: '100%',
                    backgroundColor: 'white',

                }}>
                    <div style={{ width: "8%", margin: '10px 0px 5px 15px', overflow: 'hidden' }}>
                        <img width="70%" src={CELEBRITY_CHEF_PNG}></img>
                    </div>
                    <div style={{ width: '70%' }}>
                        <div style={{ color: '#FF7A28', marginLeft: '1px', fontStyle: 'normal', fontWeight: 600, fontSize: '16px', marginTop: '20px' }}>Cloud Kitchen</div>
                        <div style={{ color: '#FF7A28', marginLeft: '1px', fontWeight: 300, fontSize: '12px', marginTop: '1px' }}>{CLOUD_KITCHEN_SUB_TEXT}</div>

                    </div>
                    <div style={{ width: '20%', overflow: 'hidden', marginTop: '15px' }}>
                        <Chip label={`Menu : Mon - Sun`} size='small' sx={{ color: 'white', fontFamily: 'Inter', backgroundColor: '#181436', fontStyle: 'normal', fontWeight: 400, fontSize: '12px', margin: '10px', borderRadius: '3px' }} />
                    </div>

                </div>


                {cloudKitchenList.map((el, index) => (
                    <div key={el.kitchenName}>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                        }} >
                            <div style={{ color: 'gray', fontStyle: 'normal', fontSize: '12px', margin: '10px 0px 10px 15px' }}> Combo items ( Per person ) : <span style={{ color: 'black', fontSize: '12px', fontStyle: 'normal', fontWeight: 600, }}> 1 Main dish + 3 Sides + 1 Kid menu</span></div>

                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row' }} onClick={(e) => handleClickRedirect(e, el)}>
                            <div style={{ width: '170px', borderRadius: '8px 8px 0px 0px', border: '1px solid #DBD6D6', margin: '10px 5px 0px 15px' }}>
                                <div style={{
                                    // height: '170px',
                                    borderRadius: '5px 5px 0px 0px',
                                    overflow: 'hidden',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    objectFit: 'cover',
                                    // border: '1px solid red'
                                }}> <img
                                        width={imageLoaded[index] ? '100%' : 0}
                                        src={imageError[index] ? fallBackImage : CLOUD_TEST_8_JPG}
                                        onLoad={() => onImageLoad(index)}
                                        onError={() => onImageError(index)}
                                        key={el._id}
                                    />
                                    {!imageLoaded[index] &&
                                        <Loader color='black' width='20px' height='20px' />}

                                </div>
                                <div style={{
                                    height: 'auto',
                                    // borderRadius: '5px 5px 0px 0px',
                                    overflow: 'hidden',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    flexWrap: 'wrap',
                                    // alignItems: 'center',
                                    // justifyContent: 'center',
                                    borderTop: '1px solid #DBD6D6',
                                    padding: '5px'
                                    // backgroundColor: '#F8F8F8'
                                }}>
                                    <div style={{ fontFamily: 'Inter', fontStyle: 'normal', fontWeight: 600, fontSize: '12px', marginTop: '1px', marginLeft: '5px' }}> Home Chedf Name </div>
                                    <div style={{ fontFamily: 'Inter', fontStyle: 'normal', fontWeight: 300, fontSize: '10px', marginTop: '2px', marginLeft: '5px', color: 'gray' }}> Cooking pass 10 years Cooking pass 10 years Cooking pass 10 years </div>


                                </div>

                            </div>
                            <div style={{ width: '170px', borderRadius: '8px 8px 0px 0px', border: '1px solid #DBD6D6', margin: '10px 5px 0px 5px' }}>
                                <div style={{
                                    // height: '170px',
                                    borderRadius: '5px 5px 0px 0px',
                                    overflow: 'hidden',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    objectFit: 'cover',
                                    // border: '1px solid red'
                                }}> <img
                                        width={imageLoaded[index] ? '100%' : 0}
                                        src={imageError[index] ? fallBackImage : CLOUD_TEST_6_JPG}
                                        onLoad={() => onImageLoad(index)}
                                        onError={() => onImageError(index)}
                                        key={el._id}
                                    />
                                    {!imageLoaded[index] &&
                                        <Loader color='black' width='20px' height='20px' />}

                                </div>
                                <div style={{
                                    height: 'auto',
                                    // borderRadius: '5px 5px 0px 0px',
                                    overflow: 'hidden',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    flexWrap: 'wrap',
                                    // alignItems: 'center',
                                    // justifyContent: 'center',
                                    borderTop: '1px solid #DBD6D6',
                                    padding: '5px'
                                    // backgroundColor: '#F8F8F8'
                                }}>
                                    <div style={{ fontFamily: 'Inter', fontStyle: 'normal', fontWeight: 600, fontSize: '12px', marginTop: '1px', marginLeft: '5px' }}> Home Chedf Name </div>
                                    <div style={{ fontFamily: 'Inter', fontStyle: 'normal', fontWeight: 300, fontSize: '10px', marginTop: '2px', marginLeft: '5px', color: 'gray' }}> Cooking pass 10 years Cooking pass 10 years Cooking pass 10 years </div>


                                </div>

                            </div>
                            <div style={{ width: '170px', borderRadius: '8px 8px 0px 0px', border: '1px solid #DBD6D6', margin: '10px 5px 0px 5px' }}>
                                <div style={{
                                    // height: '170px',
                                    borderRadius: '5px 5px 0px 0px',
                                    overflow: 'hidden',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    objectFit: 'cover',
                                    // border: '1px solid red'
                                }}> <img
                                        width={imageLoaded[index] ? '100%' : 0}
                                        src={imageError[index] ? fallBackImage : CLOUD_TEST_9_JPG}
                                        onLoad={() => onImageLoad(index)}
                                        onError={() => onImageError(index)}
                                        key={el._id}
                                    />
                                    {!imageLoaded[index] &&
                                        <Loader color='black' width='20px' height='20px' />}

                                </div>
                                <div style={{
                                    height: 'auto',
                                    // borderRadius: '5px 5px 0px 0px',
                                    overflow: 'hidden',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    flexWrap: 'wrap',
                                    // alignItems: 'center',
                                    // justifyContent: 'center',
                                    borderTop: '1px solid #DBD6D6',
                                    padding: '5px'
                                    // backgroundColor: '#F8F8F8'
                                }}>
                                    <div style={{ fontFamily: 'Inter', fontStyle: 'normal', fontWeight: 600, fontSize: '12px', marginTop: '1px', marginLeft: '5px' }}> Home Chedf Name </div>
                                    <div style={{ fontFamily: 'Inter', fontStyle: 'normal', fontWeight: 300, fontSize: '10px', marginTop: '2px', marginLeft: '5px', color: 'gray' }}> Cooking pass 10 years Cooking pass 10 years Cooking pass 10 years </div>


                                </div>

                            </div>
                            <div style={{ width: '170px', borderRadius: '8px 8px 0px 0px', border: '1px solid #DBD6D6', margin: '10px 5px 0px 5px' }}>
                                <div style={{
                                    // height: '170px',
                                    borderRadius: '5px 5px 0px 0px',
                                    overflow: 'hidden',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    objectFit: 'cover',
                                    // border: '1px solid red'
                                }}> <img
                                        width={imageLoaded[index] ? '100%' : 0}
                                        src={imageError[index] ? fallBackImage : CLOUD_TEST_3_JPG}
                                        onLoad={() => onImageLoad(index)}
                                        onError={() => onImageError(index)}
                                        key={el._id}
                                    />
                                    {!imageLoaded[index] &&
                                        <Loader color='black' width='20px' height='20px' />}

                                </div>
                                <div style={{
                                    // height: 'auto',
                                    // borderRadius: '5px 5px 0px 0px',
                                    overflow: 'hidden',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    flexWrap: 'wrap',
                                    // alignItems: 'center',
                                    // justifyContent: 'center',
                                    borderTop: '1px solid #DBD6D6',
                                    padding: '5px'
                                    // backgroundColor: '#F8F8F8'
                                }}>
                                    <div style={{ fontFamily: 'Inter', fontStyle: 'normal', fontWeight: 600, fontSize: '12px', marginTop: '1px', marginLeft: '5px' }}> Home Chedf Name </div>
                                    <div style={{ fontFamily: 'Inter', fontStyle: 'normal', fontWeight: 300, fontSize: '10px', marginTop: '2px', marginLeft: '5px', color: 'gray' }}> Cooking pass 10 years Cooking pass 10 years Cooking pass 10 years </div>

                                </div>

                            </div>

                        </div>


                    </div>
                ))}



            </div>
        </>
    )
}

export default CloudKitchen